import React from "react";
import "./loadingspinner.css";

const MARK_MIN_SIZE = 32;

const MARK_PATH =
  "M41.2961 24.5363L49.9937 15.841L46.6137 3.37271L34.1677 0L25.4701 8.69538C25.216 8.94944 24.7967 8.94944 24.5426 8.69538L15.845 0.0127029L3.37357 3.39177L0 15.8283L8.69759 24.5236C8.95172 24.7777 8.95172 25.1969 8.69759 25.451L0 34.159L3.37992 46.6273L15.8259 50L24.5235 41.2983C24.7776 41.0442 25.197 41.0379 25.4574 41.2983L34.155 49.9936L46.6264 46.6146L50 34.1717L41.3024 25.47C41.0483 25.216 41.0483 24.7967 41.3024 24.5427L41.2961 24.5363ZM38.4244 25.0127H29.4409L25.5845 38.529C25.4892 38.8719 24.9809 38.8021 24.9809 38.4464V29.2492L11.582 25.6161C11.2325 25.5208 11.3024 25.0127 11.6645 25.0127H20.5146L24.3964 11.4774C24.4981 11.1344 25 11.2043 25 11.56V20.5475L38.5133 24.4156C38.8564 24.5109 38.7865 25.0191 38.4308 25.0191L38.4244 25.0127Z";

function LoadingSpinner({
  size = 112,
  className,
  label = "Loading",
  ...svgProps
}) {
  const strokeWidth = size >= 64 ? 3 : size >= 36 ? 6 : 9;

  return (
    <svg
      {...svgProps}
      className={className ? `ow-spinner ${className}` : "ow-spinner"}
      width={size}
      height={size}
      viewBox="0 0 100 100"
      role="img"
      aria-label={label}
    >
      <circle
        className="ow-spinner-ring"
        cx="50"
        cy="50"
        r="42"
        strokeWidth={strokeWidth}
      />
      {size >= MARK_MIN_SIZE && (
        <g transform="translate(29 29) scale(0.84)">
          <g className="ow-spinner-mark">
            <path d={MARK_PATH} />
          </g>
        </g>
      )}
    </svg>
  );
}

export default LoadingSpinner;
